import axios from 'axios';

let helpers = {
  getSearch: (searchTerms, company_id) => {
    return axios({
      method: 'get',
      //url: process.env.REACT_APP_API + '/projects' + '?keywords=' + searchTerms,
      url: process.env.REACT_APP_API + '/projects?keywords=' + searchTerms + '&company_id=' + company_id,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error =>{
      return { error: error };
    });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/globalService.js